var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',_vm._l((_vm.defaultMenu),function(item){return _c('b-nav-item',{key:item.name,attrs:{"to":item.path}},[_vm._v("\n        "+_vm._s(_vm.$t(item.meta.title))+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }